// Must match server/resubscribe.js: {URL}, {lien} or {link}, in any case,
// is replaced by the member's personal link
export const LINK_PLACEHOLDER = "{URL}";
export const LINK_PLACEHOLDER_PATTERN = /\{(url|lien|link)\}/i;

export const LANGUAGES = [
  { value: "fr", label: "Français" },
  { value: "en", label: "English" },
];

// Starting text only: the sender can change anything before sending.
// To add a template, add an entry with a label and a text for each
// language in LANGUAGES.
export const RESUBSCRIBE_TEMPLATES = [
  {
    value: "expired_card",
    label: {
      fr: "Carte expirée / paiement refusé",
      en: "Expired card / payment declined",
    },
    text: {
      fr: (firstName) =>
        `Bonjour ${firstName}, le paiement de votre abonnement au Club Sutton Encore n'a pas pu être traité (carte expirée ou refusée). Pour rester membre, réabonnez-vous ici : ${LINK_PLACEHOLDER} (lien valide 7 jours)`,
      en: (firstName) =>
        `Hi ${firstName}, the payment for your Club Sutton Encore membership could not be processed (expired or declined card). To stay a member, resubscribe here: ${LINK_PLACEHOLDER} (link valid for 7 days)`,
    },
  },
  {
    value: "requested",
    label: {
      fr: "Demande de réabonnement",
      en: "Resubscription request",
    },
    text: {
      fr: (firstName) =>
        `Bonjour ${firstName}, merci de votre intérêt pour le Club Sutton Encore! Voici votre lien personnel pour vous réabonner : ${LINK_PLACEHOLDER} (lien valide 7 jours)`,
      en: (firstName) =>
        `Hi ${firstName}, thank you for your interest in Club Sutton Encore! Here is your personal link to resubscribe: ${LINK_PLACEHOLDER} (link valid for 7 days)`,
    },
  },
];

export const buildTemplate = (templateValue, language, firstName) =>
  RESUBSCRIBE_TEMPLATES.find((item) => item.value === templateValue).text[
    language
  ](firstName);
